import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/2x/gpu/x2.png'
import _imports_1 from '@/assets/2x/gpu/x4.png'
import _imports_2 from '@/assets/2x/gpu/x8.png'
import _imports_3 from '@/assets/2x/gpu/x16.png'
import _imports_4 from '@/assets/2x/gpu/x32.png'
import _imports_5 from '@/assets/2x/gpu/x64.png'
import _imports_6 from '@/assets/2x/gpu/x128.png'
import _imports_7 from '@/assets/2x/gpu/x256.png'
import _imports_8 from '@/assets/2x/gpu/x512.png'
import _imports_9 from '@/assets/2x/gpu/x1024.png'
import _imports_10 from '@/assets/2x/gpu/x2048.png'
import _imports_11 from '@/assets/2x/cpu/x2.png'
import _imports_12 from '@/assets/2x/cpu/x4.png'
import _imports_13 from '@/assets/2x/cpu/x8.png'
import _imports_14 from '@/assets/2x/cpu/x16.png'
import _imports_15 from '@/assets/2x/cpu/x32.png'
import _imports_16 from '@/assets/2x/cpu/x64.png'
import _imports_17 from '@/assets/2x/cpu/x128.png'
import _imports_18 from '@/assets/2x/cpu/x256.png'
import _imports_19 from '@/assets/2x/cpu/x512.png'
import _imports_20 from '@/assets/2x/cpu/x1024.png'
import _imports_21 from '@/assets/2x/cpu/x2048.png'
import _imports_22 from '@/assets/2x/ram/x2.png'
import _imports_23 from '@/assets/2x/ram/x4.png'
import _imports_24 from '@/assets/2x/ram/x8.png'
import _imports_25 from '@/assets/2x/ram/x16.png'
import _imports_26 from '@/assets/2x/ram/x32.png'
import _imports_27 from '@/assets/2x/ram/x64.png'
import _imports_28 from '@/assets/2x/ram/x128.png'
import _imports_29 from '@/assets/2x/ram/x256.png'
import _imports_30 from '@/assets/2x/ram/x512.png'
import _imports_31 from '@/assets/2x/ram/x1024.png'
import _imports_32 from '@/assets/2x/ram/x2048.png'
import _imports_33 from '@/assets/2x/hdd/x2.png'
import _imports_34 from '@/assets/2x/hdd/x4.png'
import _imports_35 from '@/assets/2x/hdd/x8.png'
import _imports_36 from '@/assets/2x/hdd/x16.png'
import _imports_37 from '@/assets/2x/hdd/x32.png'
import _imports_38 from '@/assets/2x/hdd/x64.png'
import _imports_39 from '@/assets/2x/hdd/x128.png'
import _imports_40 from '@/assets/2x/hdd/x256.png'
import _imports_41 from '@/assets/2x/hdd/x512.png'
import _imports_42 from '@/assets/2x/hdd/x1024.png'
import _imports_43 from '@/assets/2x/hdd/x2048.png'


const _withScopeId = n => (_pushScopeId("data-v-61cee52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tile__modal-inner" }
const _hoisted_2 = {
  width: "355",
  height: "355",
  viewBox: "0 0 355 355",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "tile__modal-background"
}
const _hoisted_3 = { filter: "url(#filter0_f3)" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M202.38 170.371L48.9555 257.701L25.8457 171.454L202.38 170.371Z",
  fill: "url(#paint0_linear)"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M152.311 183.787L328.846 182.704L305.736 96.4573L152.311 183.787Z",
  fill: "url(#paint1_linear)"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M184.787 202.307L97.4578 48.8827L183.705 25.7729L184.787 202.307Z",
  fill: "url(#paint2_linear)"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M171.372 152.239L172.454 328.773L258.701 305.663L171.372 152.239Z",
  fill: "url(#paint3_linear)"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("filter", {
  id: "filter0_f3",
  x: "46.4288",
  y: "81.2665",
  width: "264.22",
  height: "192.802",
  filterUnits: "userSpaceOnUse",
  "color-interpolation-filters": "sRGB"
}, [
  /*#__PURE__*/_createElementVNode("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }),
  /*#__PURE__*/_createElementVNode("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }),
  /*#__PURE__*/_createElementVNode("feGaussianBlur", {
    stdDeviation: "14.7209",
    result: "effect1_foregroundBlur"
  })
], -1))
const _hoisted_10 = {
  id: "paint0_linear",
  x1: "202.261",
  y1: "169.929",
  x2: "49.0468",
  y2: "210.982",
  gradientUnits: "userSpaceOnUse"
}
const _hoisted_11 = ["stop-color"]
const _hoisted_12 = ["stop-color"]
const _hoisted_13 = {
  id: "paint1_linear",
  x1: "152.193",
  y1: "183.345",
  x2: "305.408",
  y2: "142.291",
  gradientUnits: "userSpaceOnUse"
}
const _hoisted_14 = ["stop-color"]
const _hoisted_15 = ["stop-color"]
const _hoisted_16 = {
  id: "paint2_linear",
  x1: "185.23",
  y1: "202.189",
  x2: "144.176",
  y2: "48.974",
  gradientUnits: "userSpaceOnUse"
}
const _hoisted_17 = ["stop-color"]
const _hoisted_18 = ["stop-color"]
const _hoisted_19 = {
  id: "paint3_linear",
  x1: "171.814",
  y1: "152.12",
  x2: "212.868",
  y2: "305.335",
  gradientUnits: "userSpaceOnUse"
}
const _hoisted_20 = ["stop-color"]
const _hoisted_21 = ["stop-color"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_done = _resolveComponent("tp-done")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tile__modal", _ctx.classes])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("g", _hoisted_3, [
          _createElementVNode("path", {
            d: "M269.819 202.126C263.529 225.598 217.563 233.676 167.151 220.168C116.738 206.66 80.9693 176.681 87.2587 153.209C93.5481 129.736 139.514 121.659 189.927 135.167C240.339 148.675 276.108 178.653 269.819 202.126Z",
            fill: _ctx.getColor()
          }, null, 8, _hoisted_4)
        ]),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("defs", null, [
          _hoisted_9,
          _createElementVNode("linearGradient", _hoisted_10, [
            _createElementVNode("stop", {
              "stop-color": _ctx.getColor()
            }, null, 8, _hoisted_11),
            _createElementVNode("stop", {
              offset: "1",
              "stop-color": _ctx.getColor(),
              "stop-opacity": "0"
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("linearGradient", _hoisted_13, [
            _createElementVNode("stop", {
              "stop-color": _ctx.getColor()
            }, null, 8, _hoisted_14),
            _createElementVNode("stop", {
              offset: "1",
              "stop-color": _ctx.getColor(),
              "stop-opacity": "0"
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("linearGradient", _hoisted_16, [
            _createElementVNode("stop", {
              "stop-color": _ctx.getColor()
            }, null, 8, _hoisted_17),
            _createElementVNode("stop", {
              offset: "1",
              "stop-color": _ctx.getColor(),
              "stop-opacity": "0"
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("linearGradient", _hoisted_19, [
            _createElementVNode("stop", {
              "stop-color": _ctx.getColor()
            }, null, 8, _hoisted_20),
            _createElementVNode("stop", {
              offset: "1",
              "stop-color": _ctx.getColor(),
              "stop-opacity": "0"
            }, null, 8, _hoisted_21)
          ])
        ])
      ])),
      (_ctx.isImageVisible(0, 2, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(2, 4, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_1,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(4, 8, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _imports_2,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(8, 16, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            src: _imports_3,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(16, 32, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 4,
            src: _imports_4,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(32, 64, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 5,
            src: _imports_5,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(64, 128, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 6,
            src: _imports_6,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(128, 256, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 7,
            src: _imports_7,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(256, 512, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 8,
            src: _imports_8,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(512, 1024, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 9,
            src: _imports_9,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(1024, 2048, _ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 10,
            src: _imports_10,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(0, 2, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 11,
            src: _imports_11,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(2, 4, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 12,
            src: _imports_12,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(4, 8, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 13,
            src: _imports_13,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(8, 16, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 14,
            src: _imports_14,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(16, 32, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 15,
            src: _imports_15,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(32, 64, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 16,
            src: _imports_16,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(64, 128, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 17,
            src: _imports_17,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(128, 256, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 18,
            src: _imports_18,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(256, 512, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 19,
            src: _imports_19,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(512, 1024, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 20,
            src: _imports_20,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(1024, 2048, _ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", {
            key: 21,
            src: _imports_21,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(0, 2, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 22,
            src: _imports_22,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(2, 4, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 23,
            src: _imports_23,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(4, 8, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 24,
            src: _imports_24,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(8, 16, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 25,
            src: _imports_25,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(16, 32, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 26,
            src: _imports_26,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(32, 64, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 27,
            src: _imports_27,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(64, 128, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 28,
            src: _imports_28,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(128, 256, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 29,
            src: _imports_29,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(256, 512, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 30,
            src: _imports_30,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(512, 1024, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 31,
            src: _imports_31,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(1024, 2048, _ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", {
            key: 32,
            src: _imports_32,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(0, 2, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 33,
            src: _imports_33,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(2, 4, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 34,
            src: _imports_34,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(4, 8, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 35,
            src: _imports_35,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(8, 16, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 36,
            src: _imports_36,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(16, 32, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 37,
            src: _imports_37,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(32, 64, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 38,
            src: _imports_38,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(64, 128, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 39,
            src: _imports_39,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(128, 256, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 40,
            src: _imports_40,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(256, 512, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 41,
            src: _imports_41,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(512, 1024, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 42,
            src: _imports_42,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(1024, 2048, _ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", {
            key: 43,
            src: _imports_43,
            class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
          }, null, 2))
        : _createCommentVNode("", true),
      _createVNode(_component_tp_done, {
        class: "tile__modal-done-icon",
        width: 50,
        height: 50
      })
    ])
  ], 2))
}